import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user.model';
import { PermissionHelper } from '../../helpers/permission.helper';
import { Link } from '../../models/link.model';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  user: User;
  isShowing: boolean;
  isShowingLink: boolean;
  isDevelopmentMode: boolean;
  isTestMode: boolean;

  links: Array<Link> = [
    {
      name: 'Prodaja',
      icon: 'handshake',
      isOpen: false,
      sublinks: [
        {
          name: 'Zahtevi i ponude',
          link: 'request',
          icon: 'file',
        },
      ],
    },
    {
      name: 'Planiranje',
      icon: 'calendar',
      isOpen: false,
      sublinks: [
        {
          name: 'Lista poslova u razvoju',
          link: 'development',
          icon: 'stream',
        },
        {
          link: 'order',
          name: 'Radni nalozi',
          icon: 'inbox',
        }
      ],
    },
    {
      name: 'Proizvodnja',
      icon: 'hammer',
      isOpen: false,
      sublinks: [
        {
          link: 'production-plan',
          name: 'Plan proizvodnje',
          icon: 'calendar-alt',
        },
        {
          link: 'job-list',
          name: 'Lista poslova',
          icon: 'stream',
        },
      ],
    },
    {
      name: 'Administracija',
      icon: 'folder',
      isOpen: false,
      sublinks: [
        {
          link: 'shift-stats',
          name: 'Smene',
          icon: 'clock',
        },
        {
          link: 'employee',
          name: 'Zaposleni',
          icon: 'user-friends',
        },
        {
          link: 'sector',
          name: 'Sektori',
          icon: 'layer-group',
        },
      ],
    },
    {
      name: 'Materijali, proizvodi i logistika',
      icon: 'truck',
      isOpen: false,
      sublinks: [
        {
          link: 'product',
          name: 'Artikli',
          icon: 'box-open',
          route: 'product/material-catalog'
        },
        {
          link: 'procurement',
          name: 'Nabavka',
          icon: 'shopping-cart',
        },
        {
          link: 'warehouse',
          name: 'Magacin',
          icon: 'box',
        },
        {
          link: 'logistics',
          name: 'Logistika',
          icon: 'truck',
        },
      ],
    },
    {
      name: 'Statistika',
      icon: 'chart-bar',
      isOpen: false,
      sublinks: [
        {
          link: 'report',
          name: 'Dnevni izveštaj',
          icon: 'chart-pie',
        },
        {
          link: 'report',
          name: 'Preuzimanje izveštaja',
          icon: 'download',
        },
      ],
    },
  ];

  constructor(private router: Router, private userService: UserService, public permissionHelper: PermissionHelper) {}

  ngOnInit(): void {
    this.isDevelopmentMode = this.checkDevelopmentMode();
    this.isTestMode = this.checkTestMode();

    this.user = this.userService.getMe();

    this.router.events.subscribe(event => {
      this.isShowing = false;
      this.isShowingLink = false;
    });
  }

  showHideMenu(): void {
    this.isShowing = !this.isShowing;
  }

  toggleLink(link: Link): void {
    link.isOpen = !link.isOpen;
  }

  checkDevelopmentMode(): boolean {
    return location.origin === 'http://localhost:4200' || location.origin === 'https://fushit-dev.30hills.com';
  }

  checkTestMode(): boolean {
    return location.origin === 'https://app-stage.fush.rs';
  }

  isTabVisible(link: Link): boolean {
    return link.sublinks.some((sublink: { name: string; link: string; icon: string }) =>
      this.permissionHelper.userPages.includes(sublink.link)
    );
  }

  isSomeSublinkActive(link: Link): boolean {
    return link.sublinks.some((sublink: { name: string; link: string; icon: string }) => this.router.url.split('/')[1] === sublink.link);
  }

  getReportRoute(sublink: any): string {
    if (sublink.route) {
      return sublink.route;
    }
    if (sublink.link !== 'report') {
      return sublink.link;
    }
    if (sublink.name.includes('Dnevni')) {
      return 'report/daily';
    }
    if (sublink.name.includes('Preuzimanje')) {
      return 'report/download';
    }
    return sublink.link;
  }


  onSignout(): void {
    localStorage.clear();
  }
}
